import { Navigate, Route, Routes, useParams, useNavigate } from "react-router-dom";
import AboutUs from "../components/hero/AboutUs";
import Landing from "../components/landing/Landing";
import DownloadApp from "../pages/DownloadApp";
import Utilization from "../components/utilization/Utilization";
import GetInTouch from "../components/getintouch/GetInTouch";
import MapPage from "../pages/MapPage";
import EntityProfile from "../pages/EntityProfile";
import MyBusinessProfile from "../pages/MyBusinessProfile";
import Login from "../pages/Login";
import EditBusiness from "../pages/EditBusiness";
import RegisterBusinessDynamicV2 from "../pages/RegisterBusinessDynamicV2";
import Dashboard from "../pages/Dashboard";
import TermsAndConditions from "../pages/TermsAndConditions";
import { useEffect, useState } from "react";
import { Loader } from "lucide-react";

const MainRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />}></Route>
      <Route path="/download-app" element={<DownloadApp />} />
      <Route path="/PokharaStreetFestival" element={<RedirectToEvent />} />
      <Route path="/map" element={<MapPage />} />
      <Route path="/entity/:tag" element={<EntityProfile />} />
      <Route path="/business/:id" element={<BusinessOwnerRedirect />} />
      <Route path="/my-business/:id" element={<MyBusinessProfile />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/register-business" element={<RegisterBusinessDynamicV2 />} />
      <Route path="/edit-business/:id" element={<EditBusiness />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/faq" element={<Utilization />} />
      <Route path="/contact" element={<GetInTouch />} />
      <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
      <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default MainRoute;

const BusinessOwnerRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/businesses/${id}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken') || ''}`
          }
        });

        if (!response.ok) throw new Error('Failed to fetch business');
        const business = await response.json();

        if (business.tag) {
          navigate(`/entity/${business.tag}`, { replace: true });
        } else {
          setError('Business tag not found');
          setLoading(false);
        }
      } catch (err) {
        setError(err.message || 'Failed to load business');
        setLoading(false);
      }
    };

    fetchAndRedirect();
  }, [id, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-2">Error</h2>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
      <div className="flex flex-col items-center gap-6">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-orange-500 rounded-full animate-spin"></div>
          <div className="absolute inset-2 bg-gray-900 rounded-full"></div>
          <div className="absolute inset-0 flex items-center justify-center"><Loader className="w-6 h-6 text-green-500" /></div>
        </div>
        <p className="text-white text-lg font-semibold">Loading business...</p>
      </div>
    </div>
  );
};

const RedirectToEvent = () => {
  useEffect(() => {
    window.location.href = "http://events.kaha.com.np/";
  }, [])
  return <></>
}
